import { render, staticRenderFns } from "./Icon_DisplaceRight.svg?vue&type=template&id=0b8e1a0a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports